import { buildQuery } from '@calendly/http-tools';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
import Subtitle from './subtitle';
const linkCss = "l97kmvt";
const Link = forwardRef((props, ref) => {
  const as = 'a';
  return <BareButton ref={ref} {...props} as={as} className={classNames(linkCss, props.className)} />;
});
const containerCss = "c17w3lbj";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const Header = ({
  scope,
  showNewLink,
  title
}) => {
  const userGroupsUrl = '/app/admin/user_groups';
  const inviteUrl = '/app/admin/invitations/new';
  const group = {
    team: {
      title: I18n.t('publisher.title.teams'),
      url: `/teams/new?${buildQuery({
        return_to: window.location.pathname + window.location.search
      })}`,
      linkTitle: I18n.t('publisher.event_types.new_team')
    },
    user: {
      title: I18n.t('publisher.title.users'),
      url: inviteUrl,
      linkTitle: I18n.t('publisher.organization.members.new_user')
    },
    user_group: {
      title: I18n.t('publisher.title.user_groups'),
      url: userGroupsUrl,
      linkTitle: I18n.t('publisher.organization.user_groups.new_group')
    }
  }[scope];
  return <Container>
      <Subtitle>{title || group.title}</Subtitle>
      {showNewLink && <Link href={group.url}>
          {`+ ${group.linkTitle}`}
        </Link>}
    </Container>;
};
export default Header;

require("./header.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./header.js");